import { classNames } from "../../utils"

interface Props {
  initials: string
  size?: number
  isActive?: boolean
}

const InitialsAvatar = ({ initials, size = 10, isActive = false }: Props) => {
  const wrapperClassNames = classNames(
    isActive ? "bg-white text-purple-400" : "bg-gray-500 text-white",
    `inline-flex min-w-${size} h-${size} w-${size} items-center justify-center rounded-full`
  )
  return (
    <span className={wrapperClassNames}>
      <span className="font-medium leading-none">{initials}</span>
    </span>
  )
}

export default InitialsAvatar
